module.exports = __webpack_public_path__ + "static/media/LCD_1.0218d06e.svg";